module.exports = __webpack_public_path__ + "static/media/CesarMarques.746f0825.png";